import * as React from "react"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { useDispatch } from "react-redux"

import { Grid } from "@mui/material"
import useStylesSeeMoreOrganization from "./useStyleSeeMoreOrganization"
import CloseIcon from "@mui/icons-material/Close"
import { helpGetOrganizationWithID } from "../../../../../app/services/Organization/helpGetOrganizationWithID"
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
} from "../../../../../redux/actions/app"
import { getTraducTypeOrg } from "../../../../../redux/actions/Organizations"
import { useEffect } from "react"

export default function StepperSeeMoreOrganization({
  setstateSeeMore,
  item,
  suscriber,
  setLoading,
}) {
  const classes = useStylesSeeMoreOrganization()

  const dispatch = useDispatch()
  const [organization, setOrganization] = React.useState(null)
  // // get user info request
  const handleGetOrganizationWithID = async () => {
    try {
      const response = await helpGetOrganizationWithID(item.organizationId)
      setOrganization(response.data?.data)
    } catch (error) {
      // error
      dispatch(setRequestTextSnackBar())
      dispatch(setErrorTextSnackBar("Ocurrió un error. Intente nuevamente."))
    }
  }
  // get organinzation details of reducer
  useEffect(async () => {
    setLoading(true)
    await handleGetOrganizationWithID()
    setLoading(false)
  }, [])

  useEffect(async () => {
    if (organization && !organization.typeTraduc) {
      setLoading(true)

      const orgWithTypeOrgTraduc = organization
      orgWithTypeOrgTraduc.typeTraduc = await getTraducTypeOrg(
        organization.organizationTypeId,
      )
      setOrganization(orgWithTypeOrgTraduc)

      setLoading(false)
    }
  }, [organization])

  const formatDate = (date) => {
    let formattedDate
    if (date) {
      const newDate = new Date(date)
      formattedDate =
        newDate.getDate() +
        "/" +
        (newDate.getMonth() + 1) +
        "/" +
        newDate.getFullYear()
    } else {
      formattedDate = ""
    }
    return formattedDate
  }

  const SeeMoreOrganizationOfID = ({ item }) => {
    return (
      organization && (
        <>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Nombre de la organización:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {organization.organizationName || "- -"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Nombre legal de la organización:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {organization.organizationLegalName || "- -"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                CUIT de la organización:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {organization.organizationCuit || "- -"}
              </Typography>
            </Grid>
          </Grid>

          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Máximo de cuentas:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {organization.organizationMaxAccessCount || "- -"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                ID de la organización:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {organization.organizationId || "- -"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Fecha de creación:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {formatDate(organization.creationDate) || "- -"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>Creado por:</Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {organization.creationUser || "- -"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Última modificación:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {formatDate(organization.creationDate) || "- -"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>Modificado por:</Typography>
            </Grid>
            <Typography className={classes.value}>
              {organization.modificationUser || "- -"}
            </Typography>
          </Grid>
        </>
      )
    )
  }

  return (
    <Box className={classes.backgroundBox}>
      <div
        style={{
          width: "100%",
          display: "flex",
          padding: "8px 0px 8px 0px",
          justifyContent: "space-between",
          boxShadow: "0px 1px 1px #EAEAEA",
          color: "#8C8C8C",
        }}
      >
        <Typography className={classes.seeMoreTypography}>
          Información de la organización asociada al suscriptor{" "}
          {suscriber && suscriber.subscriber_name}
        </Typography>
        <CloseIcon
          style={{
            cursor: "pointer",
            paddingRight: 10,
            fontSize: "1.5rem",
          }}
          onClick={() => {
            setstateSeeMore(false)
          }}
        />
      </div>
      <Box className={classes.mainBox}>
        <SeeMoreOrganizationOfID item={item} />
      </Box>

      <ButtonClose setstateSeeMore={setstateSeeMore} />
    </Box>
  )
}

function ButtonClose({ setstateSeeMore }) {
  const classes = useStylesSeeMoreOrganization()

  return (
    <Box className={classes.closeButton}>
      <Box
        className={classes.closeButtonStyle}
        sx={{
          "&:hover": {
            bgcolor: "#1BF57F",
          },
        }}
      >
        <Typography
          onClick={() => {
            setstateSeeMore(false)
          }}
          className={classes.closeButtonTypography}
        >
          Cerrar
        </Typography>
      </Box>
    </Box>
  )
}
